// Types
import { LinkStyleProperties } from '../types/LinkProps';
export var getLinkStylePropertiesBySize = function (size) {
    return LinkStyleProperties[size];
};
//# sourceMappingURL=getLinkStylePropertiesBySize.js.map